import { useEffect, useState } from "react";
import type { ApprovalEvent } from "models/LLMs/LLMClassifierApproval";
import {
    APPROVAL_NOTICE_SEARCH_PARAM,
    approvalEventFromNoticeParam,
} from "../../utils/llmClassifierApproval";

/**
 * Picks up the approval email's deep link so the builder can explain what the recipient was told
 * and what happens next. The param is stripped on arrival -- replaced rather than pushed, as the
 * loaded version and the stepper do -- so a refresh or a version switch does not reopen the notice.
 */
export function useApprovalEmailNotice() {
    const [notice, setNotice] = useState<ApprovalEvent>();

    useEffect(() => {
        const url = new URL(window.location.href);
        const event = approvalEventFromNoticeParam(
            url.searchParams.get(APPROVAL_NOTICE_SEARCH_PARAM),
        );
        if (event === undefined) return;

        url.searchParams.delete(APPROVAL_NOTICE_SEARCH_PARAM);
        window.history.replaceState(null, "", url);
        setNotice(event);
    }, []);

    return { notice, dismissNotice: () => setNotice(undefined) };
}
